module.exports = __webpack_public_path__ + "img/issue-not-listed.97b4df1.webp";